"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.Wrapper = exports.FooterTitle = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Typography = require("../../../Typography");

var FooterTitle = (0, _styled.default)(_Typography.Body)(function (_ref) {
  var _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      fonts = _ref$theme.fonts,
      menuFooter = _ref$theme.menuFooter,
      space = _ref$theme.space;
  return {
    width: '100%',
    margin: 0,
    fontFamily: fonts[menuFooter.fontFamily.heading],
    fontWeight: 'bold',
    color: colors[menuFooter.textColor.heading],
    paddingBottom: space.medium
  };
});
exports.FooterTitle = FooterTitle;
var Wrapper = (0, _styled.default)('footer')(function (_ref2) {
  var _ref2$theme = _ref2.theme,
      space = _ref2$theme.space,
      colors = _ref2$theme.colors,
      menuFooter = _ref2$theme.menuFooter;
  return {
    background: colors[menuFooter.backgroundColor],
    paddingTop: space.xlarge
  };
});
exports.Wrapper = Wrapper;
var _default = Wrapper;
exports.default = _default;